import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
export default function ReportButton({
  className,
  isCustomer,
  onClick
}) {
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: isCustomer,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-reviews.actions.loginRequired"
    }),
    children: /*#__PURE__*/_jsx(UIButton, {
      className: className,
      disabled: !isCustomer,
      onClick: onClick,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-reviews.actions.report"
      })
    })
  });
}